import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import PublicPageLayout from '@/Themes/Default/Layouts/PublicPageLayout';
import { isAuthenticated } from '@/Helpers/auth';
import PageLayout from '@/Themes/Default/Layouts/PageLayout';

/**
 * Site's about us page
 */
const AboutUsPage = () => {
    useEffect(() => {
        document.title = 'About Us' + ' · ' + document.title;
    }, []);

    const pageContent = (
        <div className="footer-pages min-height">
            <h1>DAC Beachcroft Group</h1>
            <p></p>
            <p>The 'DAC Beachcroft Group' includes all these entities, both internationally and in the UK.</p>
            <p>Our clients may deal with any of them secure in the knowledge that the ethos, values and standards traditionally associated with DAC Beachcroft LLP are common to them all.</p>
            <ul>
                <li>DAC Beachcroft Chile Limitada</li>
                <li>DAC Beachcroft Claims Ltd</li>
                <li>DAC Beachcroft Colombia Abogados SAS</li>
                <li>DAC Beachcroft Dublin</li>
                <li>DAC Beachcroft France AARPI</li>
                <li>
                    <span>
                        <span>DAC Beachcroft Italia StArl</span>
                    </span>
                </li>
                <li>DAC Beachcroft LLP</li>
                <li>DAC Beachcroft (N.Ireland) LLP</li>
                <li>DAC Beachcroft SC</li>
                <li>DAC Beachcroft Scotland LLP</li>
                <li>DAC Beachcroft SLPU</li>
            </ul>

            <p>
                More information on each entity is provided on the{' '}
                <a data-id="5426" href="https://www.dacbeachcroft.com/en/mx/about/legal-and-regulatory" title="Legal and Regulatory">
                    Legal and Regulatory
                </a>
                &nbsp;page.
            </p>
        </div>
    );

    return isAuthenticated() ? (
        <PageLayout>{pageContent}</PageLayout>
    ) : (
        <PublicPageLayout>
            <Card>{pageContent}</Card>
        </PublicPageLayout>
    );
};

export default AboutUsPage;
